// Author SWL
// Date 2022-03-29 16:43:52

import * as model from "@/model/em/archive/EmArchToolChangeDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmArchToolChangeDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
    })
    .buildStore()
